import { render, staticRenderFns } from "./InputPopup.vue?vue&type=template&id=20205afc&scoped=true"
import script from "./InputPopup.vue?vue&type=script&lang=js"
export * from "./InputPopup.vue?vue&type=script&lang=js"
import style0 from "./InputPopup.vue?vue&type=style&index=0&id=20205afc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "20205afc",
  null
  
)

export default component.exports